import { Tooltip, TooltipTrigger, TooltipContent } from '@design-system';

import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';

import { PRODUCTS } from '@/lib/nyc-lif-demo';
import { AM_BEST_RATING_INFO, AM_BEST_CARRIER_RATINGS } from '@/util/amBestRatingData';

interface QuoteProductInfoProps {
  carrierName: string;
  productName: string;
  showLogo?: boolean;
  showRating?: boolean;
  className?: string;
}

export function QuoteProductInfo({
  carrierName,
  productName,
  showLogo = true,
  showRating = true,
  className = '',
}: QuoteProductInfoProps) {
  const { flags } = useFeatureFlags();
  const logo =
    flags.nycLifeDemo || carrierName === 'New York Life'
      ? `/logos/nyl-logo.png`
      : `/logos/${carrierName.toLowerCase()}.svg`;
  const rating = AM_BEST_CARRIER_RATINGS[carrierName];

  return (
    <div className={`flex items-start gap-4 ${className}`}>
      {showLogo && (
        <div className="border-border bg-background size-16 shrink-0 select-none rounded-lg border p-2">
          <img
            src={logo}
            alt={carrierName}
            className="size-full"
          />
        </div>
      )}
      <div className="flex max-w-56 flex-col gap-0.5">
        {showRating && rating && (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="text-xs font-semibold text-sky-600">Credit Rating&nbsp;{rating}</div>
            </TooltipTrigger>
            <TooltipContent className="max-w-sm rounded-lg border-0 bg-black/90 px-4 py-3.5 shadow-none">
              <div className="flex flex-col gap-1">
                <p className="text-sm font-bold text-white">{AM_BEST_RATING_INFO[rating]?.title}</p>
                <p className="text-sm text-white/80">{AM_BEST_RATING_INFO[rating]?.description}</p>
              </div>
            </TooltipContent>
          </Tooltip>
        )}
        <h2 className="text-primary-dark wrap-break-words text-sm font-semibold leading-snug sm:text-base">
          {flags.nycLifeDemo ? (PRODUCTS as any)?.[carrierName] : productName}
        </h2>
        <div
          data-testid="quote-card-carrier"
          className="text-muted-foreground text-xs"
        >
          {flags.nycLifeDemo ? 'New York Life' : carrierName}
        </div>
      </div>
    </div>
  );
}
